import { RootState } from '@modules/App/redux/store';
import { AsyncData } from '@shared/interfaces/asyncData';
import { SignInActivitiesPageData } from './types';

export const signInActivitiesSelector = (state: RootState): AsyncData<SignInActivitiesPageData> =>
  state.signInActivities.signInActivities;

export const totalSignInActivitiesSelector = (state: RootState): number => state.signInActivities.total;

export const signInActivitiesCacheSelector = (state: RootState): { [key: string]: SignInActivitiesPageData } =>
  state.signInActivities.cache;
